import React from 'react'
import { useDispatch } from 'react-redux'
import { closeModal } from '@/components/composed/Modal/actions'
import { FinancingUxFeedbackModalAlert } from '../FinancingUxFeedbackModalAlert'
import { messages } from './messages'

export const FinancingUxFeedbackModalError = () => {
  const dispatch = useDispatch()

  const onErrorAction = () => {
    dispatch(closeModal())
  }

  return <FinancingUxFeedbackModalAlert icon="red/info" title={messages.error} actionMessage={messages.action} onActions={onErrorAction} />
}
